module.exports = __webpack_public_path__ + "img/rjcEgf.5ecdfa4.jpg";